module.exports = __webpack_public_path__ + "img/Location.1d38e8f9.svg";